// Children: full child profile management — interests, coach selection,
// consent-per-child, plus the child-specific speech & learning panels.
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "../../ui/button";
import { ChildCard } from "../ChildCard";
import { SpeechGoals } from "../SpeechGoals";
import { SoundRequests } from "../SoundRequests";
import { VideoModelingTracker } from "../VideoModelingTracker";
import { ListeningFavorites } from "../ListeningFavorites";

export const ChildrenSection = ({ children, notice, onChanged }) => {
  const navigate = useNavigate();
  return (
    <div className="space-y-8" data-testid="dash-section-children">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-extrabold font-display">Children</h1>
          <p className="text-muted-foreground mt-1">
            Profiles, interests, coaches, speech targets and per-child consent.
          </p>
        </div>
        <Button className="rounded-full gap-2" onClick={() => navigate("/onboarding")}
          data-testid="children-add-child-button">
          <Plus className="h-4 w-4" aria-hidden="true" /> Add a child
        </Button>
      </div>

      {children === null ? (
        <p className="text-muted-foreground">Loading…</p>
      ) : children.length === 0 ? (
        <div className="bg-card rounded-2xl border border-dashed border-border p-12 text-center space-y-4"
          data-testid="dashboard-empty-state">
          <h2 className="text-base md:text-lg font-bold font-display">No child profiles yet</h2>
          <Button className="rounded-full gap-2" onClick={() => navigate("/onboarding")}
            data-testid="empty-add-child-button">
            <Plus className="h-4 w-4" aria-hidden="true" /> Set up a child profile
          </Button>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="children-grid">
          {children.map((child) => (
            <ChildCard key={child.child_id} child={child} notice={notice} onChanged={onChanged} />
          ))}
        </div>
      )}

      <div className="space-y-4">
        <SpeechGoals />
        <SoundRequests />
        <VideoModelingTracker />
        <ListeningFavorites />
      </div>
    </div>
  );
};
